import styled from "styled-components"

export const CalendarWrapper = styled.div`
    height: 100%;    
    display: grid;
    grid-template-columns: 230px 1fr;
    gap: 16px;
`

export const CalendarWrapperNoSidebar = styled.div`
    height: 100%;    
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`